// extracted by mini-css-extract-plugin
export var text = "index-module--text--ofjvK";
export var textCenterBanner = "index-module--textCenterBanner--5x+QE";